import React from "react"
import PropTypes from "prop-types"
import clsx from "clsx"

function BurgerIcon(props) {
    const { active } = props
    const className = clsx("burger-icon fill-white", active && "burger-icon-active")
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect className="burger-icon-line-1" y="0" width="24" height="4" rx="2" />
            <rect className="burger-icon-line-2" y="10" width="24" height="4" rx="2" />
            <rect className="burger-icon-line-3" y="20" width="24" height="4" rx="2" />
        </svg>
    )
}

export default BurgerIcon

BurgerIcon.propTypes = {
    active: PropTypes.bool,
}
